// @flow

import QuickSearchList from './QuickSearchList'

export default QuickSearchList
